import { CityActions } from '../actions';
import { CityState } from '../city-state';

export const initialState: CityState['tempBaseStore'] = undefined;

export function reducer(
  state = initialState,
  action: CityActions.DelayedSetActiveBaseStore | CityActions.ClearTemporaryBaseStore,
): CityState['tempBaseStore'] {
  switch (action.type) {
    case CityActions.DELAYED_SET_ACTIVE_BASE_STORE: {
      return action.payload;
    }

    case CityActions.CLEAR_TEMPORARY_ACTIVE_BASE_STORE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
